import { Pipe, PipeTransform } from '@angular/core';
import { convertStatusClassNames } from '../utils';

@Pipe({
    name: 'convertStatusClassNames',
    standalone: false
})
export class ConvertStatusClassNamesPipe implements PipeTransform {
  convertClassNames: (className: string) => string = convertStatusClassNames;
  elementName = '';
  className = '';
  status = '';
  convertedValue = '';

  transform(value: string): string {
    value = value.toLowerCase();
    if (value.includes('__')) {
      const splittedValue = value.split('__');
      this.className = splittedValue[0];
      this.elementName = splittedValue[1].slice(0, splittedValue[1].indexOf('_'));
      this.status = splittedValue[1].slice(splittedValue[1].indexOf('_') + 1);

      this.convertedValue = this.className + '__' + this.elementName + '_' + convertStatusClassNames(this.status);
    } else {
      this.className = value.slice(0, value.indexOf('_'));
      this.status = value.slice(value.indexOf('_') + 1);
      this.convertedValue = this.className + '_' + convertStatusClassNames(this.status);
    }
    return this.convertedValue;
  }
}
